export const variousAsn = 'VARIOUS';

export const SUPER_ADMINS = [
  'Gavin.Dillon@mrl.com.au',
  'Jeff.Scherpenzeel@mrl.com.au',
  'Krissa.DeTorres@mrl.com.au',
  'Estelle.Chappuis@mrl.com.au',
  'James.Bargerbos@mrl.com.au',
  'Billy.Li@mrl.com.au',
  'liheng.zhang@mrl.com.au',
  'subhani.munasinghe@mrl.com.au'
];

export const UAT_SUPER_ADMINS = [...SUPER_ADMINS, ...['sai.damerla@mrl.com.au']];

export const QM_MAX_ATTACHMENTS = 10;
export const QM_MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024;

export const QM_ATTACHMENT_COMMENT_PREFIX = 'Attachment added: ';
export const QM_CREATION_ATTACHMENT_COMMENT_PREFIX_SINGLE = 'Creation attachment added: ';
export const QM_CREATION_ATTACHMENT_COMMENT_PREFIX_MULTI = 'Creation attachments added (';

export const QM_INTEGRATION_ONLY_REASON_CODES = ['POD_CREATED_QM', 'ASN_OVERDUE_7_DAYS'];
